// 不加loginRole的接口
import util from './util.js'

// 教师端
import staff from './staff.js'

// 政府端
import government from './government.js'

// 专家端
import expert from './expert.js'

// 公共接口
import common from './common.js'

export default {
  util,
  staff,
  government,
  expert,
  common
}